import type { Suggestion } from './api'

/** An ObjectID: letters, numbers and hyphens - the object form's rule (objects/schema.ts), checked again on the server. */
export const OBJECT_ID_RE = /^[A-Za-z0-9-]+$/

const idPart = (text: string) =>
    text
        .normalize('NFKD')
        .replace(/[^A-Za-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .toUpperCase()

/**
 * An id to start from for the new object a suggestion asks for: the anchor's id and the role
 * ("OG-APP-EX-DOMAIN-CONTROLLER"), so it sorts beside what it belongs to and says what it is.
 * Only a start - the person names it.
 */
export function suggestedObjectId(s: Pick<Suggestion, 'anchor' | 'expected'>): string {
    return [idPart(s.anchor.id), idPart(s.expected.role ?? '')].filter(Boolean).join('-').slice(0, 60).replace(/-+$/, '')
}
